import React from "react";
import { Label } from "./ui/label";
import { RadioGroup, RadioGroupItem } from "./ui/radio-group";
import { sortLabels } from "../lib/posColors";

const Radio = ({ id, value, label }) => (
    <div className="flex items-center gap-2">
        <RadioGroupItem id={id} data-testid={id} value={value} className="border-slate-500 text-blue-400" />
        <Label htmlFor={id} className="text-sm text-slate-200 cursor-pointer">{label}</Label>
    </div>
);

// Colour assignment mode: uniform vs per position (auto / manual with a per-position colour list).
export function ColorModeControls({ tray, setTray, mode, units, t }) {
    const assign = tray.color_assign === "manual" ? "manual" : "auto";
    const colorOf = Object.fromEntries(units.map((u) => [u.label, u.color]));
    const labels = sortLabels(units.map((u) => u.label));
    const setPos = (l, hex) => setTray((tr) => {
        const pc = { ...(tr.pos_colors || {}) };
        if (hex) pc[l] = hex; else delete pc[l];
        return { ...tr, pos_colors: pc };
    });
    return (
        <div data-testid="color-mode-controls" className="space-y-2 border border-[#1e293b] rounded-md p-2 bg-[#0b0f17]">
            <Label className="text-xs text-slate-400 font-mono">{t("pv_color_mode")}</Label>
            <RadioGroup value={mode} className="gap-1.5" onValueChange={(v) => setTray((tr) => ({ ...tr, color_mode: v, bubble_color: v === "uniform" ? (tr.bubble_color || "#2563eb") : tr.bubble_color }))}>
                <Radio id="color-mode-uniform" value="uniform" label={t("pv_color_uniform")} />
                <Radio id="color-mode-position" value="position" label={t("pv_color_position")} />
            </RadioGroup>
            {mode === "position" && (
                <div className="pl-5 space-y-2">
                    <RadioGroup value={assign} className="gap-1.5" onValueChange={(v) => setTray((tr) => ({ ...tr, color_assign: v }))}>
                        <Radio id="color-assign-auto" value="auto" label={t("pv_color_auto")} />
                        <Radio id="color-assign-manual" value="manual" label={t("pv_color_manual")} />
                    </RadioGroup>
                    {assign === "manual" && (
                        <div data-testid="pos-color-list" className="max-h-40 overflow-y-auto space-y-1 pr-1">
                            {labels.map((l) => (
                                <div key={l} className="flex items-center gap-2 text-xs font-mono text-slate-200">
                                    <input type="color" data-testid={`pos-color-${l}`} value={colorOf[l] || "#2563eb"} onChange={(e) => setPos(l, e.target.value)}
                                        className="w-6 h-6 rounded cursor-pointer bg-transparent border border-[#1e293b] p-0" />
                                    <span className="flex-1 truncate">{l}</span>
                                    {tray.pos_colors?.[l] && (
                                        <button data-testid={`pos-color-reset-${l}`} onClick={() => setPos(l, null)} className="text-[10px] text-slate-400 hover:text-white underline">{t("pv_auto")}</button>
                                    )}
                                </div>
                            ))}
                        </div>
                    )}
                </div>
            )}
        </div>
    );
}
